import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import useProjectExportCreate from "~/hooks/useProjectExportCreate";
import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import useRequireCurrentClient from "~/modules/client/hooks/useRequireCurrentClient";
import { ProjectExportCreateForm, ProjectExportCreateFormInput } from "~/shared/components/ProjectExportCreateForm";

import useRequireCurrentProject from "../hooks/useRequireCurrentProject";

export function ProjectExportCreateScreen() {
    const { t } = useTranslation("projectExport");
    const navigate = useNavigate();

    const { client } = useRequireCurrentClient();
    const { project } = useRequireCurrentProject();
    const { createProjectExport, error } = useProjectExportCreate();

    const handleSubmit = async (data: ProjectExportCreateFormInput) => {
        await createProjectExport({
            ...data,
            clientId: client.id,
            projectIds: [project.id],
        });

        navigate(`..`);
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("ProjectExportCreateScreen.title")}>
                <ProjectExportCreateForm
                    defaultValues={{ projectIds: [project.id] }}
                    onSubmit={handleSubmit}
                    error={error}
                    isProjectsSelectable={false}
                />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
